import { Pagination } from 'element-ui'
import './style.scss'

const YPagination = Pagination
YPagination.$depends = [Pagination]
YPagination.$name = 'y-pagination'
YPagination._name = 'Pagination 分页'

export default YPagination
